import React, { FC } from 'react'
import styles from 'styles/components/card.module.scss'
import { CheckoutItemType } from 'types/checkoutItem'
import { HorizontalLine } from 'components/Utility'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { getBreads } from 'reducks/bread/selectors'
import { findBreadShortName } from 'lib/helper'
import { getSchedules } from 'reducks/schedule/selectors'
import { TimeSaleTag } from '../../Tag'

type Props = {
  items: CheckoutItemType[]
}

const OrderCardBodyItems: FC<Props> = (props) => {
  const { items } = props
  const breads = useSelector((state: State) => getBreads(state))
  const schedules = useSelector((state: State) => getSchedules(state))

  return (
    <ul className={styles.order__body__items}>
      {items
        .filter((item) => item.quantity !== 0) // 引当在庫数判定の改修によりquantityが0の場合もありえるが非表示とする
        .sort((a, b) => {
          const aBread = breads.find((bread) => bread.bread_ref?.id === a.bread_ref.id)
          const bBread = breads.find((bread) => bread.bread_ref?.id === b.bread_ref.id)
          // bread の order の昇順で並び替える
          return (aBread?.order || 9999) - (bBread?.order || 9999)
        })
        .map((item, index) => {
          const hasPickupableTimes = schedules
            .filter((schedule) => schedule.bread_ref.id === item.bread_ref.id && schedule.type === item.type)
            .some((schedule) => schedule.default_stocks.length > 1)
          return (
            <li key={`${item.bread_ref.id}-${item.pickupable_time}`}>
              <div className={styles.order__body__item}>
                <div>
                  <p className={styles.order__body__item__name}>
                    {findBreadShortName(breads, item.bread_name, item.bread_ref)}
                    {item.original_price && item.original_price !== item.price && <TimeSaleTag tagName={'セール'} />}
                  </p>
                  {hasPickupableTimes && (
                    <p className={styles.order__body__item__description}>{item.pickupable_time}受渡解禁分</p>
                  )}
                  {item.choice !== '' && <p className={styles.order__body__item__description}>{item.choice}</p>}
                </div>
                <div className={styles.order__body__item__quantity}>{item.quantity}個</div>
              </div>
              {items.length !== index + 1 && <HorizontalLine verticalMargin={0} />}
            </li>
          )
        })}
    </ul>
  )
}

export default OrderCardBodyItems
